import api from './api'

export type GeofenceType = 'EXCLUSION' | 'POST' | 'INCLUSION'

export interface Geofence {
    id: number
    name: string
    type: GeofenceType
    active: boolean
    notifyOnEntry: boolean
    notifyOnExit: boolean
    activeFrom?: string | null
    activeTo?: string | null
    polygon: number[][] // anillo [lon, lat]
}

export interface GeofenceRequest {
    name: string
    type: GeofenceType
    active?: boolean
    notifyOnEntry?: boolean
    notifyOnExit?: boolean
    activeFrom?: string
    activeTo?: string
    // círculo (el backend lo convierte a polígono)
    centerLat?: number
    centerLon?: number
    radiusMeters?: number
    // o polígono explícito [lon, lat]
    polygon?: number[][]
}

export interface GeofenceEvent {
    id: number
    geofenceId: number
    userId: string
    callsign?: string
    eventType: 'ENTRY' | 'EXIT' | 'DWELL'
    breach: boolean
    occurredAt: string
}

export const geofenceService = {
    async list(): Promise<Geofence[]> {
        return (await api.get<Geofence[]>('/api/v1/geofences')).data
    },
    async create(req: GeofenceRequest): Promise<Geofence> {
        return (await api.post<Geofence>('/api/v1/geofences', req)).data
    },
    async update(id: number, req: GeofenceRequest): Promise<Geofence> {
        return (await api.put<Geofence>(`/api/v1/geofences/${id}`, req)).data
    },
    async remove(id: number): Promise<void> {
        await api.delete(`/api/v1/geofences/${id}`)
    },
    async events(breaches = false, limit = 50): Promise<GeofenceEvent[]> {
        return (await api.get<GeofenceEvent[]>('/api/v1/geofences/events', {
            params: { breaches, limit },
        })).data
    },
}
